import React from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';

import styles from './personal-information-display.module.scss';

type PersonalInformationDisplayProps = {
  firstname: string;
  lastname?: string;
  username?: string;
  bio?: string;
};

const PersonalInformationDisplay: React.FC<PersonalInformationDisplayProps> = ({
  firstname,
  lastname,
  username,
  bio,
}) => {
  const { t } = useTranslation('account-settings');

  return (
    <dl className={styles.personalInformationDisplay}>
      <div className={styles.personalInformationDisplay__row}>
        <dt className={styles.personalInformationDisplay__label}>
          {t('ACCOUNT_SETTINGS.ACCOUNT_INFORMATION.FIRST_NAME')}
        </dt>
        <dd
          className={styles.personalInformationDisplay__value}
          data-cy="account-info-first-name"
        >
          {firstname || '-'}
        </dd>
      </div>
      <div className={styles.personalInformationDisplay__row}>
        <dt className={styles.personalInformationDisplay__label}>
          {t('ACCOUNT_SETTINGS.ACCOUNT_INFORMATION.LAST_NAME')}
        </dt>
        <dd
          className={styles.personalInformationDisplay__value}
          data-cy="account-info-last-name"
        >
          {lastname || '-'}
        </dd>
      </div>
      <div className={styles.personalInformationDisplay__row}>
        <dt className={styles.personalInformationDisplay__label}>
          {t('ACCOUNT_SETTINGS.ACCOUNT_INFORMATION.USERNAME')}
        </dt>
        <dd
          className={styles.personalInformationDisplay__value}
          data-cy="account-info-username"
        >
          {username || '-'}
        </dd>
      </div>

      <div className={styles.personalInformationDisplay__row}>
        <dt className={styles.personalInformationDisplay__label}>{t('ACCOUNT_SETTINGS.ACCOUNT_INFORMATION.BIO')}</dt>
        <dd
          className={clsx(styles.personalInformationDisplay__value, styles['personalInformationDisplay__value--bio'])}
          data-cy="account-info-bio"
        >
          {bio || '-'}
        </dd>
      </div>
    </dl>
  );
};

export default PersonalInformationDisplay;
